module.exports = __webpack_public_path__ + "static/media/icon-show.6dd7a7b2.png";